export const queryKeys = {
  checkRut: 'checkRut',
  user: 'user',
  obfuscatedContactData: 'obfuscated',
  accounts: 'accounts',
  movements: 'movements',
  certificates: 'certificates',
  necessity: 'necessity',
  alerts: 'alerts',
  campaigns: 'campaigns',
  informativeSectionInfo: 'informativeSectionInfo',
  specialties: 'specialties',
  appointments: 'appointments',
  professionals: {
    getBySpecialtyId: 'getBySpecialtyId',
    getDaysAvailability: 'getDaysAvailability',
    getHoursAvailability: 'getHoursAvailability'
  },
  subscriptionCard: {
    getByCardId: 'getByCardId'
  },  
  availableProducts: 'availableProducts',
  paymentsRecurrentData : 'paymentsRecurrentData' ,
  paymentsMethodListAssociated: 'paymentsMethodListAssociated' ,
  paymentsMethodRegister: 'paymentsMethodRegister' ,
  paymentsAssociateProduct: 'paymentsAssociateProduct' ,
  paymentsPolicyAvaible: 'paymentsPolicyAvaible' ,
  paymentsMethodDelete: 'paymentsMethodDelete' ,
  paymentsAssociateAnotherMethod: 'paymentsAssociateAnotherMethod' ,
  paymentsNotification: 'paymentsNotification' ,
  paymentsKillSession: 'paymentsKillSession'
  


// ADD NEW KEY HERE
}
